<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-purchases', params: {id: accountId}}">
              {{ $t('accountPurchase.detailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ resourceId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('accountPurchase.detailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="details">
              <purchase-details :details="details"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import PurchaseDetails from 'src/components/Purchase/PurchaseDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountPurchase",
  components: {
    PurchaseDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    resourceId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountPurchase']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountPurchase({accountID: this.accountId, resourceID: this.resourceId});
  },
  computed: {
    ...mapState({
      loading: state => state.account_purchase.loading,
      details: state => state.account_purchase.data,
    }),
  },
}
</script>

